<script setup>
import NRFeedback from "@/Components/NR-Feedback.vue"
import {onMounted} from "vue";

const { layout } = defineProps({
    layout: {
        type: String,
        default: null
    },
    title: {
        type: String,
        default: null
    },
    headerColour: {
        type: String,
        default: 'white'
    },
    footerColour: {
        type: String,
        default: 'footer'
    },
})

const isLayoutSE = (layout === 'SE')
</script>

<template>
    <v-app color="white">
        <header :class="headerColour">
            <v-container name="default" class="py-3">
                <v-row>
                    <v-col cols="6" class="px-0 py-0">
                        <slot name="header" />
                        <slot name="headerSecondary"/>
                    </v-col>
                </v-row>
            </v-container>
        </header>
        <v-layout>
            <v-main tabindex="2">
                <div class="banner">
                    <v-container name="default">
                        <v-row class="w-100">
                            <v-col class="py-0" >
                                <h1 :class="{'se-header-title':isLayoutSE, 'sw-header-title':!isLayoutSE}" tabindex="3">{{ title }}</h1>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <v-container name="default">
                    <v-row class="w-100">
                        <v-col cols="12">
                            <slot name="noGutter"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-3 pr-8">
                            <NR-Feedback/>
                        </v-col>
                    </v-row>
                    <v-row class="w-100">
                        <v-col>
                            <slot/>
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-layout>
        <v-footer :color="footerColour" class="footer-border-top py-5">
            <v-container>
                <v-row class="w-100">
                    <v-col cols="12" class="pt-8" style="z-index: 2;">
                        <slot name="footer"/>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
    </v-app>
</template>

<style scoped>
.banner {
    border-bottom: 10px solid rgb(var(--v-theme-headerBannerBackgroundTertiary));
}

.banner h1 {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-size: 48px;
}
</style>
